module.exports = __webpack_public_path__ + "img/enterAge.4cb481bc.png";